





























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ContaBancariaModel } from "@/models/commons/ContaBancariaModel";
import { PrestadorModel } from "@/models/cadastros/assistencia/PrestadorModel";
import { CONTA_CORRENTE } from "@/models/commons/TipoContaBancariaModel";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import ContabilOrcamentoFrotaService from "@/service/ContabilOrcamentoFrotaService";

@Component({
  components: {
    GsModalDialog
  },
})
export default class ConsultarLeads extends Vue {
  
  loading = false;

  listaLeadVeiculoFrota = [
    {
      tipoVeiculo: ""
    }
  ]

  retorno = {
    nome: "",
    telefone: "",
    email: "",
    frotaPropria: false,
    quantidadeFrota: "",
    leadVeiculoFrota: this.listaLeadVeiculoFrota,
    autorizaContato: ""
  };
  frotaPropria = "";
  autorizaContato = "";
  tiposVeiculosConcatenados = "";

  mounted() {
    this.consultar();
  }

  consultar(){
    if (this.$route.params.idLeads) {
      ContabilOrcamentoFrotaService.consultarLeadFrotaId(
        this.$route.params.idLeads
      ).then((response) => {
        let resultado = response.data;
        this.retorno = resultado;

        /*if (this.retorno.frotaPropria) {
          this.frotaPropria = "Sim";
        } else {
          this.frotaPropria = "Não";
        }*/
        this.frotaPropria = this.retorno.frotaPropria ? 'Sim' : 'Não';
        this.autorizaContato = this.retorno.autorizaContato == "S" ? "Sim" : "Não";  
        this.tiposVeiculosConcatenados = this.retorno.leadVeiculoFrota.map(tipoVeiculos => tipoVeiculos.tipoVeiculo).join('; ');
      }
    )}
  }

  voltarPagina() {
    this.$router.back();
  }
}
